
import { ResumeContact, ResumeEducation } from '@/models/Resume'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
    name: "education",
    props: {
        education: {
            type: Array as PropType<ResumeEducation[]>,
            required: true
        } 
    }
})
